// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__bIHy2","active":"sidebar_active__c8zRS","right":"sidebar_right__BJRVY"};